import {
  forwardRef,
  type ComponentProps,
  type ReactNode,
} from "react";

import { cn } from "@workspace/ui/lib/utils";

export const ProblemAnswerCard = forwardRef<
  HTMLDivElement,
  ComponentProps<"div">
>(function ProblemAnswerCard({ className, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        "overflow-hidden rounded-lg border border-gray-200 bg-white transition-[width] duration-300 ease-in-out dark:border-gray-700 dark:bg-gray-800",
        className,
      )}
      {...props}
    />
  );
});

export function ProblemAnswerNumber({
  problemNumber,
  totalProblems,
}: {
  problemNumber: number;
  totalProblems: number;
}) {
  return (
    <div className="px-1 pb-1 text-xs tabular-nums text-gray-400 dark:text-gray-500">
      {problemNumber}번 / {totalProblems}문제
    </div>
  );
}

export function ProblemAnswerTable({
  className,
  ...props
}: ComponentProps<"table">) {
  return (
    <table
      className={cn("w-full table-fixed text-sm", className)}
      {...props}
    />
  );
}

export function ProblemAnswerRow({
  label,
  children,
  tone = "default",
  className,
  labelClassName,
  contentClassName,
}: {
  label: ReactNode;
  children: ReactNode;
  tone?: "default" | "exam";
  className?: string;
  labelClassName?: string;
  contentClassName?: string;
}) {
  const exam = tone === "exam";

  return (
    <tr
      className={cn(
        "border-b border-gray-200 last:border-b-0 dark:border-gray-700",
        className,
      )}
    >
      <th
        scope="row"
        className={cn(
          "w-[50px] p-3 text-left font-semibold dark:text-white",
          exam
            ? "bg-red-100 dark:bg-red-900"
            : "bg-gray-50 dark:bg-gray-700/50",
          labelClassName,
        )}
      >
        {label}
      </th>
      <td
        className={cn(
          "p-3 dark:text-white",
          exam && "bg-red-100 dark:bg-red-900",
          contentClassName,
        )}
      >
        {children}
      </td>
    </tr>
  );
}
